import { createAction } from './core';
// PUBLIC API
export const sendSignupCode = createAction('operations/send-signup-code', ['SignupCode', 'User', 'AuthDomainConfig', 'AuthDomainRule']);
// PUBLIC API
export const verifySignupCode = createAction('operations/verify-signup-code', ['SignupCode']);
// PUBLIC API
export const updateIsUserAdminById = createAction('operations/update-is-user-admin-by-id', ['User']);
// PUBLIC API
export const updateUserPrimaryLocation = createAction('operations/update-user-primary-location', ['User', 'LocationMembership', 'Location']);
// PUBLIC API
export const updateLocationSubscription = createAction('operations/update-location-subscription', ['LocationMembership', 'User']);
// PUBLIC API
export const createLocationMembershipForUser = createAction('operations/create-location-membership-for-user', ['LocationMembership', 'Location', 'User']);
// PUBLIC API
export const deleteLocationMembershipForUser = createAction('operations/delete-location-membership-for-user', ['LocationMembership', 'User']);
// PUBLIC API
export const updateUserProfile = createAction('operations/update-user-profile', ['User']);
// PUBLIC API
export const updateUserByAdmin = createAction('operations/update-user-by-admin', ['User', 'LocationMembership']);
// PUBLIC API
export const deleteUserById = createAction('operations/delete-user-by-id', ['User']);
// PUBLIC API
export const restoreUserById = createAction('operations/restore-user-by-id', ['User']);
// PUBLIC API
export const deleteMultipleUsers = createAction('operations/delete-multiple-users', ['User']);
// PUBLIC API
export const restoreMultipleUsers = createAction('operations/restore-multiple-users', ['User']);
// PUBLIC API
export const createUserByAdmin = createAction('operations/create-user-by-admin', ['User', 'LocationMembership']);
// PUBLIC API
export const resetUserPasswordByAdmin = createAction('operations/reset-user-password-by-admin', ['User']);
// PUBLIC API
export const requestPasswordResetByAdmin = createAction('operations/request-password-reset-by-admin', ['User']);
// PUBLIC API
export const updateUserApprovalStatus = createAction('operations/update-user-approval-status', ['User']);
// PUBLIC API
export const updateUserModeratorStatus = createAction('operations/update-user-moderator-status', ['User']);
// PUBLIC API
export const completeInstanceOnboarding = createAction('operations/complete-instance-onboarding', ['GlobalConfig', 'Location', 'LocationMembership', 'LocationTypeDefinition', 'User']);
// PUBLIC API
export const skipInstanceOnboarding = createAction('operations/skip-instance-onboarding', ['GlobalConfig', 'User']);
// PUBLIC API
export const generateGptResponse = createAction('operations/generate-gpt-response', ['User', 'Task', 'GptResponse']);
// PUBLIC API
export const createTask = createAction('operations/create-task', ['Task']);
// PUBLIC API
export const deleteTask = createAction('operations/delete-task', ['Task']);
// PUBLIC API
export const updateTask = createAction('operations/update-task', ['Task']);
// PUBLIC API
export const generateCheckoutSession = createAction('operations/generate-checkout-session', ['User']);
// PUBLIC API
export const createFile = createAction('operations/create-file', ['User', 'File']);
// PUBLIC API
export const updateAuthDomainConfig = createAction('operations/update-auth-domain-config', ['AuthDomainConfig']);
// PUBLIC API
export const addAuthDomainRule = createAction('operations/add-auth-domain-rule', ['AuthDomainRule']);
// PUBLIC API
export const removeAuthDomainRule = createAction('operations/remove-auth-domain-rule', ['AuthDomainRule']);
// PUBLIC API
export const updateGeoBlockConfig = createAction('operations/update-geo-block-config', ['GeoBlockConfig']);
// PUBLIC API
export const addGeoBlockRule = createAction('operations/add-geo-block-rule', ['GeoBlockRule']);
// PUBLIC API
export const removeGeoBlockRule = createAction('operations/remove-geo-block-rule', ['GeoBlockRule']);
// PUBLIC API
export const requestLocationAccess = createAction('operations/request-location-access', ['MembershipAccessRequest', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const joinLocationAsMember = createAction('operations/join-location-as-member', ['Location', 'LocationMembership', 'User']);
// PUBLIC API
export const joinLocationWithCode = createAction('operations/join-location-with-code', ['MembershipAccessRequest', 'Location', 'LocationMembership', 'InviteCode', 'User']);
// PUBLIC API
export const approveAccessByPlatform = createAction('operations/approve-access-by-platform', ['MembershipAccessRequest', 'LocationMembership', 'User']);
// PUBLIC API
export const approveAccessByBuildingManager = createAction('operations/approve-access-by-building-manager', ['MembershipAccessRequest', 'LocationMembership', 'User']);
// PUBLIC API
export const rejectAccessRequest = createAction('operations/reject-access-request', ['MembershipAccessRequest', 'LocationMembership', 'User']);
// PUBLIC API
export const grantBuildingServicesAccess = createAction('operations/grant-building-services-access', ['MembershipAccessRequest', 'LocationMembership', 'User']);
// PUBLIC API
export const createBuildingServiceRequest = createAction('operations/create-building-service-request', ['Content', 'LocationMembership', 'User']);
// PUBLIC API
export const updateBuildingServiceRequestStatus = createAction('operations/update-building-service-request-status', ['Content', 'LocationMembership', 'User']);
// PUBLIC API
export const subscribeToLocation = createAction('operations/subscribe-to-location', ['LocationMembership', 'Location']);
// PUBLIC API
export const verifyWithCode = createAction('operations/verify-with-code', ['LocationMembership', 'InviteCode']);
// PUBLIC API
export const generateInviteCode = createAction('operations/generate-invite-code', ['InviteCode', 'LocationMembership']);
// PUBLIC API
export const deactivateInviteCode = createAction('operations/deactivate-invite-code', ['InviteCode', 'LocationMembership']);
// PUBLIC API
export const createLocation = createAction('operations/create-location', ['Location', 'LocationMembership']);
// PUBLIC API
export const updateLocation = createAction('operations/update-location', ['Location']);
// PUBLIC API
export const deleteLocation = createAction('operations/delete-location', ['Location', 'LocationMembership', 'Content', 'Event', 'InviteCode']);
// PUBLIC API
export const setLocationParent = createAction('operations/set-location-parent', ['Location']);
// PUBLIC API
export const deleteAllLocationEntries = createAction('operations/delete-all-location-entries', ['Location', 'Content', 'Event', 'LocationMembership']);
// PUBLIC API
export const removeLocationMembership = createAction('operations/remove-location-membership', ['LocationMembership']);
// PUBLIC API
export const createLocationType = createAction('operations/create-location-type', ['LocationTypeDefinition']);
// PUBLIC API
export const updateLocationType = createAction('operations/update-location-type', ['LocationTypeDefinition']);
// PUBLIC API
export const deleteLocationType = createAction('operations/delete-location-type', ['LocationTypeDefinition', 'Location']);
// PUBLIC API
export const reorderLocationTypes = createAction('operations/reorder-location-types', ['LocationTypeDefinition']);
// PUBLIC API
export const updateLocationSectionOverrides = createAction('operations/update-location-section-overrides', ['LocationSectionOverride', 'Location']);
// PUBLIC API
export const updatePlatformSectionVisibility = createAction('operations/update-platform-section-visibility', ['PlatformSectionVisibility']);
// PUBLIC API
export const updatePlatformOptionalFieldVisibility = createAction('operations/update-platform-optional-field-visibility', ['PlatformOptionalFieldVisibility']);
// PUBLIC API
export const createContent = createAction('operations/create-content', ['Content', 'LocationMembership']);
// PUBLIC API
export const updateContent = createAction('operations/update-content', ['Content', 'LocationMembership']);
// PUBLIC API
export const deleteContent = createAction('operations/delete-content', ['Content', 'LocationMembership']);
// PUBLIC API
export const createEvent = createAction('operations/create-event', ['Event', 'Location', 'LocationMembership']);
// PUBLIC API
export const updateEvent = createAction('operations/update-event', ['Event', 'Location', 'LocationMembership']);
// PUBLIC API
export const deleteEvent = createAction('operations/delete-event', ['Event', 'LocationMembership']);
// PUBLIC API
export const rsvpToEvent = createAction('operations/rsvp-to-event', ['EventAttendee', 'Event', 'LocationMembership']);
// PUBLIC API
export const createTenant = createAction('operations/create-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const updateTenant = createAction('operations/update-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const deleteTenant = createAction('operations/delete-tenant', ['Tenant', 'Location', 'User', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const createNotice = createAction('operations/create-notice', ['Content', 'Location', 'LocationMembership', 'LocationPermission', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateNotice = createAction('operations/update-notice', ['Content', 'Location', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const deleteNotice = createAction('operations/delete-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const approveNotice = createAction('operations/approve-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const pinNotice = createAction('operations/pin-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const archiveNotice = createAction('operations/archive-notice', ['Content', 'LocationMembership', 'LocationPermission']);
// PUBLIC API
export const createFacility = createAction('operations/create-facility', ['Content', 'Location', 'LocationMembership', 'LocationPermission', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateFacility = createAction('operations/update-facility', ['Content', 'Location', 'LocationMembership', 'LocationPermission', 'User']);
// PUBLIC API
export const deleteFacility = createAction('operations/delete-facility', ['Content', 'LocationMembership', 'LocationPermission', 'User']);
// PUBLIC API
export const createBuySell = createAction('operations/create-buy-sell', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateBuySell = createAction('operations/update-buy-sell', ['Content', 'Location']);
// PUBLIC API
export const deleteBuySell = createAction('operations/delete-buy-sell', ['Content']);
// PUBLIC API
export const createTextbook = createAction('operations/create-textbook', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateTextbook = createAction('operations/update-textbook', ['Content', 'Location']);
// PUBLIC API
export const deleteTextbook = createAction('operations/delete-textbook', ['Content']);
// PUBLIC API
export const createAccommodation = createAction('operations/create-accommodation', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest', 'Notification']);
// PUBLIC API
export const updateAccommodation = createAction('operations/update-accommodation', ['Content', 'Location', 'User']);
// PUBLIC API
export const deleteAccommodation = createAction('operations/delete-accommodation', ['Content', 'User']);
// PUBLIC API
export const createRequestOffer = createAction('operations/create-request-offer', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateRequestOffer = createAction('operations/update-request-offer', ['Content', 'Location']);
// PUBLIC API
export const deleteRequestOffer = createAction('operations/delete-request-offer', ['Content']);
// PUBLIC API
export const createCarpool = createAction('operations/create-carpool', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateCarpool = createAction('operations/update-carpool', ['Content', 'Location']);
// PUBLIC API
export const deleteCarpool = createAction('operations/delete-carpool', ['Content']);
// PUBLIC API
export const createFoodCourtItem = createAction('operations/create-food-court-item', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateFoodCourtItem = createAction('operations/update-food-court-item', ['Content']);
// PUBLIC API
export const deleteFoodCourtItem = createAction('operations/delete-food-court-item', ['Content']);
// PUBLIC API
export const createLostFound = createAction('operations/create-lost-found', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateLostFound = createAction('operations/update-lost-found', ['Content', 'Location']);
// PUBLIC API
export const deleteLostFound = createAction('operations/delete-lost-found', ['Content']);
// PUBLIC API
export const createCommunityPost = createAction('operations/create-community-post', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateCommunityPost = createAction('operations/update-community-post', ['Content']);
// PUBLIC API
export const deleteCommunityPost = createAction('operations/delete-community-post', ['Content']);
// PUBLIC API
export const createRetailStore = createAction('operations/create-retail-store', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateRetailStore = createAction('operations/update-retail-store', ['Content', 'Location']);
// PUBLIC API
export const deleteRetailStore = createAction('operations/delete-retail-store', ['Content']);
// PUBLIC API
export const createService = createAction('operations/create-service', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateService = createAction('operations/update-service', ['Content', 'Location']);
// PUBLIC API
export const deleteService = createAction('operations/delete-service', ['Content']);
// PUBLIC API
export const createJob = createAction('operations/create-job', ['Content', 'Location', 'LocationMembership', 'User', 'ApprovalRequest']);
// PUBLIC API
export const updateJob = createAction('operations/update-job', ['Content', 'Location']);
// PUBLIC API
export const deleteJob = createAction('operations/delete-job', ['Content']);
// PUBLIC API
export const createUpkeepRequest = createAction('operations/create-upkeep-request', ['Content', 'LocationMembership', 'Notification']);
// PUBLIC API
export const updateUpkeepRequestStatus = createAction('operations/update-upkeep-request-status', ['Content', 'LocationMembership', 'Notification']);
// PUBLIC API
export const createBuildingDocument = createAction('operations/create-building-document', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const deleteBuildingDocument = createAction('operations/delete-building-document', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const grantPermissions = createAction('operations/grant-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const revokePermissions = createAction('operations/revoke-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const approvePost = createAction('operations/approve-post', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification']);
// PUBLIC API
export const rejectPost = createAction('operations/reject-post', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'ContentRecycleBin']);
// PUBLIC API
export const checkPermission = createAction('operations/check-permission', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const submitForApproval = createAction('operations/submit-for-approval', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const approveContent = createAction('operations/approve-content', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'LocationPermission', 'LocationMembership']);
// PUBLIC API
export const rejectContent = createAction('operations/reject-content', ['ApprovalRequest', 'Content', 'User', 'Location', 'Notification', 'LocationPermission', 'LocationMembership', 'ContentRecycleBin']);
// PUBLIC API
export const cancelApprovalRequest = createAction('operations/cancel-approval-request', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const markNotificationRead = createAction('operations/mark-notification-read', ['Notification', 'User']);
// PUBLIC API
export const toggleContentSubscription = createAction('operations/toggle-content-subscription', ['ContentSubscription', 'Content', 'User']);
// PUBLIC API
export const markAllNotificationsRead = createAction('operations/mark-all-notifications-read', ['Notification', 'User']);
// PUBLIC API
export const deleteNotification = createAction('operations/delete-notification', ['Notification', 'User']);
// PUBLIC API
export const createNotification = createAction('operations/create-notification', ['Notification', 'User', 'Location']);
// PUBLIC API
export const restoreFromRecycleBin = createAction('operations/restore-from-recycle-bin', ['ContentRecycleBin', 'Content', 'User', 'Location']);
// PUBLIC API
export const extendDeletionDate = createAction('operations/extend-deletion-date', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const cleanupExpiredEntries = createAction('operations/cleanup-expired-entries', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const deleteRecycleBinEntry = createAction('operations/delete-recycle-bin-entry', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const createFeedback = createAction('operations/create-feedback', ['Feedback', 'User', 'Location']);
// PUBLIC API
export const createReport = createAction('operations/create-report', ['Report', 'User', 'Location', 'Content']);
// PUBLIC API
export const updateReportStatus = createAction('operations/update-report-status', ['Report']);
// PUBLIC API
export const updateGlobalConfig = createAction('operations/update-global-config', ['GlobalConfig']);
//# sourceMappingURL=index.js.map